module.exports = __webpack_public_path__ + "static/media/mention-commentaire.5907116d.png";